const PlayIcon = ({ color, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.03918 2.27276C4.2401 1.76899 3.19922 2.34324 3.19922 3.28787V12.7128C3.19922 13.6574 4.2401 14.2317 5.03918 13.7279L12.5141 9.01544C13.2608 8.54468 13.2608 7.45597 12.5141 6.98522L5.03918 2.27276Z"
        fill={color ?? "white"}
      />
    </svg>
  );
};

export default PlayIcon;
